module.exports = __webpack_public_path__ + "img/User.34447f24.svg";